/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AttachmentBlobTypes {
  Discrepancy = 'discrepancy',
  DiscrepancyFine = 'discrepancy_fine',
  LoadCarrier = 'load_carrier',
  PalletTicket = 'pallet_ticket',
  Receipt = 'receipt'
}
